import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import withMobileDialog from '@material-ui/core/withMobileDialog';
import { withStyles } from '@material-ui/core/styles/index';
import red from '@material-ui/core/colors/red';
import YellowWarning from "../../images/icons/yellowWarning.svg";
import {post} from "../../modules/utility";
import GenericSavingDialog from "./GenericSavingDialog";

import Transition from './Transition';

const styles = (theme) => ({
	dialogPadding : {
		padding : 10,
		[theme.breakpoints.up('md')]: {
			padding : '20px 50px 20px 50px',
		}
	},
	dialogPaper : {
		overflow: 'scroll',
		width: '60%',
		maxWidth: '90%',
	},
	question : {
		padding: '20px 20px 10px 20px',
		fontWeight : 600,
		fontSize : 16,
		textAlign : 'right',
	},
	actions : {
		padding : 10,
	},
	warningButton : {
		borderRadius : 100,
		color: theme.palette.getContrastText(red[500]),
		backgroundColor: red[500],
		'&:hover': {
			backgroundColor: red[700],
		},
	},
	warning : {
		fontSize : 20,
		padding : 20,
		border : '1px solid #eee',
		backgroundColor : '#f7f7f7',
		borderRadius : 5,
		marginBottom : 20,
	},
	warningIcon : {
		display: 'inline-block',
		width: 36,
		height: 36,
		backgroundPosition: 'center',
		backgroundSize: 'cover',
		verticalAlign: 'middle',
		marginRight : 5,
		backgroundImage: `url('${YellowWarning}')`,
	},
});


class ConfirmInvalidateMissingBill extends PureComponent {

	constructor (props) {
		super(props);
		this.state = {
			isSavingOpen : false,
			savingStatus : undefined,
		};
	}

	onChange = (event, fieldName) => {
		this.setState({ [fieldName] : event.target.value });
	};

	handleClose = () => {
		this.setState({
			isSavingOpen : false,
			savingStatus : undefined,
		}, this.props.onClose);
	};

	handleInvalidate = () => {
		const {
			//onClose,
			showErrors,
			missingBill,
		} = this.props;

		if (!missingBill) {
			return showErrors(['Missing vendor bill']);
		}

		const { bolNumberToInvoiceId, carrierPoNumberToInvoiceId} = missingBill;

		this.setState({
			isSavingOpen: true,
			savingStatus: 'activating'
		});

		setTimeout(() => {
			if (bolNumberToInvoiceId) {
				post({
					method: 'bolNumberToInvoice.remove',
					params: {
						bolNumberToInvoiceId,
					},
					callback: err => {
						this.setState({isSearching: false});

						if (err) {
							this.setState({isSavingOpen: false});
							return showErrors((_.isArray(err)) ? err : [err]);
						}
						this.setState({
							savingStatus: 'done'
						});

						this.props.afterSave({
							bolNumberToInvoiceId
						});
					}
				});

			} else if (carrierPoNumberToInvoiceId) {
				post({
					method: 'carrierPoNumberToInvoice.remove',
					params: {
						carrierPoNumberToInvoiceId,
					},
					callback: err => {
						this.setState({isSearching: false});

						if (err) {
							this.setState({isSavingOpen: false});
							return showErrors((_.isArray(err)) ? err : [err]);
						}

						this.setState({
							savingStatus: 'done',
						});

						this.props.afterSave({
							carrierPoNumberToInvoiceId
						});
					}
				});
			} else {
				showErrors(['Missing bolNumber of carrier bill number']);
			}
		}, 350);
	};

	render() {
		const { classes, open, missingBill } = this.props;

		if (!missingBill) { return null; }
		const {isSavingOpen, savingStatus} = this.state;
		const { billDisplay } = missingBill;
		return (
			<Dialog
				maxWidth='md'
				open={open}
				TransitionComponent={Transition}
				onClose={this.handleClose}
				classes={{
					paper: classes.dialogPaper
				}}
			>
				<DialogTitle>Mark Bill as NOT Missing</DialogTitle>
				<DialogContent>
					<div className={classes.warning}>
						Marking a bill as NOT missing means that the vendor either will never send us this
						bill (for example some of our carriers blend their freight bill in with their fuel bill)
						or that we have entered the bill directly into Quickbooks so there will not be a
						linkage in FMP.
					</div>

					<div className={classes.warning}>
						<div style={{marginBottom : 5, textTransform : 'uppercase', fontSize : 13, color : '#666'}}>
							Bill Details
						</div>
						{billDisplay}
					</div>

				</DialogContent>

				<div className={classes.question}>
					Are you sure you want to mark this bill as not missing?
				</div>

				<DialogActions>
					<div className={classes.actions}>
						<Button onClick={this.handleClose}>
							Close
						</Button>
						<Button
							disabled={isSavingOpen}
							variant="contained"
							onClick={this.handleInvalidate}
							className={classes.warningButton}
						>
							Yes, mark bill as not missing
						</Button>
					</div>
				</DialogActions>

				<GenericSavingDialog
					open={isSavingOpen}
					onClose={this.handleClose}
					onContinue={this.handleClose}
					processingText={"Marking bill as NOT missing..."}
					successText={"Bill successfully marked as not missing and removed from list."}
					status={savingStatus}
				/>

			</Dialog>
		);
	}
}

ConfirmInvalidateMissingBill.propTypes = {
	open : PropTypes.bool,
	onClose : PropTypes.func.isRequired,
	classes: PropTypes.object.isRequired,

	//- Could be either
	missingBill : PropTypes.object,
	afterSave : PropTypes.func.isRequired,
	showErrors : PropTypes.func.isRequired,
};

export default _.flow([
	withStyles(styles),
	withMobileDialog(),
])(ConfirmInvalidateMissingBill);